import { Grid2, Typography, Box, Button, Modal, Slide, } from "@mui/material"
import { memo, useMemo, useEffect, useState } from "react";
import Table from "../../components/Table.js";
import AddIcon from '@mui/icons-material/Add';
import {
    getOwners,
    getInspectors,
    getOrganizations,
    getUsersData,
    getAnimals
} from "../../api/index.js";
import Spinner from "../../components/Spinner.js";
import { useSnackbar } from "../../utils/index.js";
import OwnerForm from "../../components/forms/OwnerForm.js";
import Form from "../../components/Form.js";
import { useLocation } from "react-router-dom";
import AnimalForm from "../../components/forms/AnimalForm.js"
import FormPopup from "../../components/popups/FormPopup.js";
import useListStyles from "../../components/styles/List.js";
import {
    registrationCodeHeader,
    sexHeader,
    birthDateHeader,
    animalOwnerHeader,
    flockCodeHeader,
    sireCodeHeader,
    damCodeHeader,
    cullingCodeHeader,
    cullingDateHeader,
    createdAtHeader,
} from "../../components/TableHeaders.js";

const sexTranslates = [
    { en: "male", gr: "Άρρεν" },
    { en: "female", gr: "Θήλυ" },
    { en: "all", gr: "Όλα" },
];


const AnimalsList = () => {
    const classes = useListStyles();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [owners, setOwners] = useState([]);
    const [inspectors, setInspectors] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [users, setUsers] = useState([]);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isUpdateOpen, setIsUpdateOpen] = useState(false);
    const [ownerToUpdate, setOwnerToUpdate] = useState(null);
    const [animalToUpdate, setAnimalToUpdate] = useState(null);
    const [animalOwner, setAnimalOwner] = useState(null);
    const [animalOwnerId, setAnimalOwnerId] = useState(null);
    const [animals, setAnimals] = useState([]);
    const [ownersDropdownValues, setOwnersDropdownValues] = useState([]);
    const [isOwnerSelected, setIsOwnerSelected] = useState(false);
    const [selectedOwner, setSelectedOwner] = useState([]);
    const [isOwnerUpdateOpen, setIsOwnerUpdateOpen] = useState(false);
    const [isPdfPopupOpen, setIsPdfPopupOpen] = useState(false);


    const { error } = useSnackbar();

    const fetchData = async () => {
        // setIsLoading(true)
        const { owners } = await getOwners();
        setOwners(owners);
        const ownersDropdownArr = []
        for (var owner of owners) {
            ownersDropdownArr.push({ value: `${owner.code} - ${owner.lastName} ${owner.firstName}`, text: `${owner.code} - ${owner.lastName} ${owner.firstName}` });
        }
        setOwnersDropdownValues(ownersDropdownArr);

        // const { animals } = await getAnimals();
        // setAnimals(animals);
        const { inspectors } = await getInspectors();
        setInspectors(inspectors);

        const { organizations } = await getOrganizations();
        setOrganizations(organizations);

        const { users } = await getUsersData();
        setUsers(users)
        // setIsLoading(false)
    }


    useEffect(() => {
        fetchData();
    }, [location.search]);


    const selectFormContent = [
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή",
            required: true,
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const pdfFormContent = [
        {
            customType: "dropdown",
            id: "sex",
            items: [
                { value: "Θήλυ", text: "Θήλυ" },
                { value: "Άρρεν", text: "Άρρεν" },
                { value: "Όλα", text: "Όλα" },
            ],
            placeholder: "Φύλο",
            required: true,
            defaultValue: "Όλα"
        },
        {
            customType: "dropdown",
            id: "owner",
            items: ownersDropdownValues,
            placeholder: "Εκτροφή",
            required: true,
            defaultValue: `${selectedOwner.code} - ${selectedOwner.lastName} ${selectedOwner.firstName}`
        },
        {
            customType: "button",
            id: "submit",
            type: "submit",
            text: "Υποβολή"
        },
    ]

    const handleAnimalCodeClick = (value) => {
        const animal = animals.find((animal) => animal.registrationCode === value)
        const animalToUpdate = { ...animal };
        const animalsOwner = owners.find((owner) => owner._id === animalToUpdate.owner);
        animalsOwner ? animalToUpdate.owner = `${animalsOwner.lastName} ${animalsOwner.firstName}` : animalToUpdate.owner = null;
        setAnimalOwner(animalsOwner);
        setAnimalOwnerId(animalsOwner?._id);
        setAnimalToUpdate(animalToUpdate);
        setIsUpdateOpen(true);
    }

    const handelOwnerClick = (value) => {
        setIsOwnerUpdateOpen(true);
        const owner = owners.find((owner) => owner._id === value)
        const ownerToUpdate = { ...owner };
        const ownersInspector = inspectors.find((inspector) => inspector._id === ownerToUpdate.inspector);
        ownersInspector ? ownerToUpdate.inspector = `${ownersInspector.lastName} ${ownersInspector.firstName}` : ownerToUpdate.inspector = null;

        if (ownerToUpdate?.organization) {
            const ownersOrganization = organizations.find((organization) => organization._id === owner.organization);
            ownersOrganization ? ownerToUpdate.organization = ownersOrganization.name : ownerToUpdate.organization = null;
        }

        if (ownerToUpdate.user) {
            const ownersUser = users.find((user) => user._id === ownerToUpdate.user);
            ownersUser ? ownerToUpdate.user = ownersUser.username : ownerToUpdate.user = null;
        }
        setOwnerToUpdate(ownerToUpdate);
    }

    const tableColumns = useMemo(() => [
        registrationCodeHeader(handleAnimalCodeClick),
        sexHeader,
        birthDateHeader,
        animalOwnerHeader(handelOwnerClick, selectedOwner),
        flockCodeHeader,
        sireCodeHeader(handleAnimalCodeClick),
        damCodeHeader(handleAnimalCodeClick),
        cullingCodeHeader,
        cullingDateHeader,
        createdAtHeader
    ])

    const handleOwnerSelectSubmit = async (values) => {
        setIsLoading(true);
        const selOwner = owners.find((owner) => `${owner.code} - ${owner.lastName} ${owner.firstName}` === values.owner)
        setSelectedOwner(selOwner);
        const selectedOwnerId = selOwner?._id;
        const { success: successCode, animals, message } = await getAnimals(selectedOwnerId);
        if (successCode) {
            setAnimals(animals);
            setIsOwnerSelected(true);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const fetchAnimals = async (ownerId) => {
        setIsLoading(true);
        const { success: successCode, animals, message } = await getAnimals(ownerId);
        if (successCode) {
            setAnimals(animals);
            setIsOwnerSelected(true);
        } else {
            error(message);
        }
        setIsLoading(false);
    }

    const handlePdfSubmit = (values) => {
        const sexToSend = sexTranslates.find((sexTranslate) => sexTranslate.gr === values.sex).en;
        const ownerIdToSend = owners.find((owner) => `${owner.code} - ${owner.lastName} ${owner.firstName}` === values.owner)?._id
        window.location.assign(`/print/animals?sex=${sexToSend}&owner=${ownerIdToSend}`)
    }

    return (
        <>
            <Spinner open={isLoading} />
            {!isOwnerSelected && (
                <>
                    <Box className={classes.outerBox}>
                        <Box container flexDirection="column" className={classes.innerBox}>
                            <Typography variant="h5" sx={{ margin: "1rem" }}>
                                Επιλέξτε την εκτροφή που σας ενδιαφέρει:
                            </Typography>
                            <Form content={selectFormContent} onSubmit={handleOwnerSelectSubmit} />
                        </Box>
                    </Box>
                </>
            )}
            {isOwnerSelected && (
                <>
                    <FormPopup
                        isOpen={isPdfPopupOpen}
                        title={"Ζώα"}
                        innerText="Συμπληρώστε τα πεδία που σας ενδιαφέρουν"
                        declineText="Ακύρωση"
                        acceptText="PDF"
                        formContent={pdfFormContent}
                        onDecline={() => setIsPdfPopupOpen(false)}
                        onAccept={(values) => handlePdfSubmit(values)}
                    />
                    <Modal open={isCreateOpen} onClose={() => setIsCreateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Slide direction="left" in={isCreateOpen} mountOnEnter unmountOnExit>
                            <Box className={classes.modalContent}>
                                <Typography variant="h5" className={classes.modal_title}>
                                    Προσθήκη Ζώου
                                </Typography>
                                <AnimalForm
                                    datePickerWidth="100%"
                                    isCreate={true}
                                    isFromList={true}
                                    setIsCreateOpen={setIsCreateOpen}
                                    fetchListData={fetchAnimals}
                                    ownerId={selectedOwner._id}
                                    ownersDropdownValues={ownersDropdownValues}
                                    fetchedOwners={owners}
                                    fetchedOwner={selectedOwner} />
                            </Box>
                        </Slide>
                    </Modal>
                    <Modal open={isOwnerUpdateOpen} onClose={() => setIsOwnerUpdateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Slide direction="left" in={isOwnerUpdateOpen} mountOnEnter unmountOnExit>
                            <Box className={classes.modalContent}>
                                <Typography variant="h5" className={classes.modal_title}>
                                    Επεξεργασία Εκτροφής
                                </Typography>
                                <OwnerForm
                                    datePickerWidth="100%"
                                    isCreate={false}
                                    isFromList={true}
                                    setIsCreateOpen={setIsOwnerUpdateOpen}
                                    fetchedOwner={ownerToUpdate}
                                    setFetchedOwner={setOwnerToUpdate}
                                    ownerId={ownerToUpdate?._id} />
                            </Box>
                        </Slide>
                    </Modal>
                    <Modal open={isUpdateOpen} onClose={() => setIsUpdateOpen(false)} sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Slide direction="left" in={isUpdateOpen} mountOnEnter unmountOnExit>
                            <Box className={classes.modalContent}>
                                <Typography variant="h5" className={classes.modal_title}>
                                    Επεξεργασία Ζώου
                                </Typography>
                                <AnimalForm
                                    datePickerWidth="100%"
                                    isCreate={false}
                                    isFromList={true}
                                    setIsCreateOpen={setIsUpdateOpen}
                                    fetchListData={fetchAnimals}
                                    fetchedOwner={animalOwner}
                                    setFetchedOwner={setAnimalToUpdate}
                                    ownerId={animalOwnerId}
                                    flockCode={animalToUpdate?.flockCode}
                                    fetchedAnimal={animalToUpdate}
                                    setFetchedAnimal={setAnimalToUpdate}
                                    fetchedOwners={owners}
                                    ownersDropdownValues={ownersDropdownValues}
                                />
                            </Box>
                        </Slide>
                    </Modal>
                    <Grid2 container className={classes.container} direction="column" sx={{ marginTop: "1rem", marginLeft: "3rem" }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "90%", marginBottom: "1rem" }}>
                            <Typography variant="h5" className={classes.form_title}>
                                Ζώα
                            </Typography>
                            <Box>
                                <Button variant="contained" sx={{ marginRight: "0.5rem", backgroundColor: "secondary.main" }} onClick={() => setIsPdfPopupOpen(true)}>
                                    PDF
                                </Button>
                                <Button variant="contained" sx={{ backgroundColor: "primary.main" }} onClick={() => setIsCreateOpen(true)}>
                                    <AddIcon sx={{ mr: "0.5rem" }} />Προσθήκη Ζώου
                                </Button>
                            </Box>
                        </Box>
                        <Table
                            data={animals}
                            noDataText={isLoading ? "Φόρτωση..." : "Δεν υπάρχουν Ζώα!"}
                            columns={tableColumns}
                            defaultSorted={[{ id: "createdAt", desc: true }]}
                            ownerId={selectedOwner._id}
                            dropdownOptions={[{ value: "Άρρεν", label: "Άρρεν" }, { value: "Θήλυ", label: "Θήλυ" }]}
                        />
                    </Grid2>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            onClick={() => setIsOwnerSelected(false)}
                            sx={{
                                marginTop: "1rem",
                                padding: "0.5rem 1rem",
                                backgroundColor: "third",
                                color: "secondary.main",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                                variant: "h5",
                            }}
                        >
                            Πίσω
                        </Button>
                    </Box>
                </>
            )}
        </>
    );
}

export default memo(AnimalsList);
